export default __webpack_public_path__ + "static/media/DNo.16-1.1f911c0a.jpg";